(function () {
  function fan(wrap) {
    if (!wrap || wrap.classList.contains('mfac-callout-fanned')) return;
    wrap.classList.add('mfac-callout-fanned');
    wrap.classList.add('aos-animate');
    wrap.querySelectorAll('[data-aos="image-fade-in"]').forEach(function (el) {
      el.classList.add('aos-animate');
    });
  }

  function setup() {
    var sections = document.querySelectorAll('[id*="collection_callout"]');
    if (!sections.length) return;

    sections.forEach(function (sec) {
      sec.style.setProperty('background', '#ffffff', 'important');
      sec.style.setProperty('overflow', 'visible', 'important');
      var wrap = sec.querySelector('.callout-images');
      if (!wrap) return;

      // Already on screen at load (rare) — fan after a tick so transition can run
      var rect = wrap.getBoundingClientRect();
      var inView = rect.top < window.innerHeight * 0.92 && rect.bottom > 0;

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio > 0.12) {
              // rAF so first paint is stacked, then bloom
              requestAnimationFrame(function () {
                requestAnimationFrame(function () { fan(wrap); });
              });
              io.unobserve(entry.target);
            }
          });
        }, { root: null, rootMargin: '0px 0px -8% 0px', threshold: [0, 0.12, 0.25] });
        io.observe(wrap);

        // Safety: if observer never fires (odd browsers), fan after idle
        setTimeout(function () {
          if (!wrap.classList.contains('mfac-callout-fanned')) fan(wrap);
        }, 12000);
      } else if (inView) {
        requestAnimationFrame(function () { fan(wrap); });
      } else {
        // no IO — fan on first scroll near
        var onScroll = function () {
          var r = wrap.getBoundingClientRect();
          if (r.top < window.innerHeight * 0.9 && r.bottom > 40) {
            fan(wrap);
            window.removeEventListener('scroll', onScroll);
          }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        setTimeout(function () { if (!wrap.classList.contains('mfac-callout-fanned')) fan(wrap); }, 12000);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
